import { createQueryKeys } from "./create-query-keys";
import { getNotificationLogs, } from "../api/generated/wrappers/notification";
const notificationQueryKeys = createQueryKeys("notification", {
    logs: (params) => ({
        queryKey: ["logs", params],
        queryFn: () => getNotificationLogs(params),
    }),
});
export default notificationQueryKeys;
